import { Badge as MantineBadge } from "@mantine/core";
import { polymorphicComponentWrapper } from "../../utilities";
import styles from "./badge.module.scss";
import type { CustomBadgeFactory, IProps } from "./badge.types";
import { Icon } from "../icon";

/**
 * Badge component for displaying labels, tags, or status indicators.
 * @param {IconDefinition} props.leftIcon - Optional icon to display on the left side of the badge.
 * @param {IconDefinition} props.rightIcon - Optional icon to display on the right side of the badge.
 * @param {boolean} props.noEllipsis - When true, show the label in full and let the badge overflow.
 * @returns {JSX.Element} The Badge component.
 */
const Badge = polymorphicComponentWrapper<CustomBadgeFactory, IProps>(
    "Badge",
    ({ leftIcon, rightIcon, noEllipsis = false, ...otherProps }, ref) => {
        return (
            <MantineBadge
                ref={ref}
                size="sm"
                leftSection={leftIcon ? <Icon icon={leftIcon} data-testid="badge-left-icon" /> : undefined}
                rightSection={rightIcon ? <Icon icon={rightIcon} data-testid="badge-right-icon" /> : undefined}
                classNames={{ root: styles["root"], label: styles["label"], section: styles["section"] }}
                data-color={otherProps.color}
                data-no-ellipsis={noEllipsis}
                {...otherProps}
            />
        );
    }
);

export { Badge };
